// client/src/components/Participants.jsx
import React from 'react';

const Participants = ({ 
  remoteUsers, 
  localUser, 
  onMuteUser, 
  onRemoveUser,
  isHost = false,
  raisedHands = {} 
}) => {
  const allUsers = [
    {
      userId: 'local',
      nickname: localUser.nickname,
      audioEnabled: localUser.audioEnabled,
      videoEnabled: localUser.videoEnabled,
      isLocal: true,
      isSpeaking: false,
      networkStrength: 'good'
    },
    ...remoteUsers
  ];

  return (
    <div className="participants-panel">
      <div className="participants-header">
        <h3>Participants ({allUsers.length})</h3>
        <div className="participants-actions">
          {isHost && (
            <button className="action-btn mute-all-btn" title="Mute All" onClick={() => alert('Mute all functionality to be implemented')}>
              🔇
            </button>
          )}
          <button className="action-btn" title="More Options">
            ⋯
          </button>
        </div>
      </div>
      
      <div className="participants-list">
        {allUsers.map((user) => (
          <div key={user.userId} className={`participant-item ${user.isSpeaking ? 'speaking' : ''}`}>
            <div className="participant-info">
              <div className="participant-avatar">
                {user.videoEnabled ? (
                  <div className="video-avatar">📹</div>
                ) : (
                  <div className="text-avatar">
                    {user.nickname.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>
              
              <div className="participant-details">
                <div className="participant-name">
                  {user.nickname}
                  {user.isLocal && <span className="you-label"> (You)</span>}
                  {raisedHands[user.userId] && <span className="raised-hand-indicator"> ✋</span>}
                </div>
                <div className="participant-status">
                  {user.audioEnabled ? '🎤' : '🔇'} 
                  {user.videoEnabled ? '📹' : '📷'}
                  {user.isSpeaking && <span className="speaking-indicator">Speaking</span>}
                </div>
              </div>
            </div>
            
            <div className="participant-controls">
              {!user.isLocal && (
                <>
                  <button
                    onClick={() => onMuteUser && onMuteUser(user.userId)}
                    className="control-icon-btn"
                    title={user.audioEnabled ? 'Mute' : 'Unmute'}
                  >
                    {user.audioEnabled ? '🔇' : '🎤'}
                  </button>
                  {isHost && (
                    <button
                      onClick={() => onRemoveUser && onRemoveUser(user.userId)}
                      className="control-icon-btn remove-btn"
                      title="Remove"
                    >
                      ❌
                    </button>
                  )}
                </>
              )}
              
              <div className={`network-indicator ${user.networkStrength}`}>
                <div className="signal-bars">
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Participants;
